export default __webpack_public_path__ + "static/media/ce-rosetta-mobile.f7608f06.png";